/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Settings_Dirs_Delete_Dialog_Description_BulkInputs */

const es_settings_dirs_delete_dialog_description_bulk = /** @type {(inputs: Settings_Dirs_Delete_Dialog_Description_BulkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estás por eliminar permanentemente ${i?.count} carpeta(s) y todos sus archivos. Esta acción no se puede deshacer.`)
};

const en_settings_dirs_delete_dialog_description_bulk = /** @type {(inputs: Settings_Dirs_Delete_Dialog_Description_BulkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You are about to permanently delete ${i?.count} directory(ies) and all their files. This action cannot be undone.`)
};

/**
* | output |
* | --- |
* | "You are about to permanently delete {count} directory(ies) and all their files. This action cannot be undone." |
*
* @param {Settings_Dirs_Delete_Dialog_Description_BulkInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_dirs_delete_dialog_description_bulk = /** @type {((inputs: Settings_Dirs_Delete_Dialog_Description_BulkInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Dirs_Delete_Dialog_Description_BulkInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_dirs_delete_dialog_description_bulk(inputs)
	return en_settings_dirs_delete_dialog_description_bulk(inputs)
});
export { settings_dirs_delete_dialog_description_bulk as "settings.dirs.delete_dialog.description_bulk" }